import { Set }           from 'immutable';
import {
  call,
  put,
  takeEvery,
}                        from 'redux-saga/effects';
import {
  fetchApiResourceFailure,
  fetchApiResourceRequest,
  fetchApiResourceSuccess,
  KEY_RESOURCE_IRI,
}                        from '../../actions/apiResourceActions';
import UserFriendlyError from '../../errors/UserFriendlyError';
import Raven             from '../../modules/raven-cdn';
import API               from '../../services/API';


/**
 * Cache of requests in progress
 */
let requestsInProgressCache = Set();


function* handleApiFetchRequests() {

  yield takeEvery(fetchApiResourceRequest, fetchApiResource);

}


function* fetchApiResource(action) {

  const {payload, payload: {[KEY_RESOURCE_IRI]: resourceIRI}, meta} = action;

  if (requestsInProgressCache.contains(resourceIRI)) {

    return;

  }

  requestsInProgressCache = requestsInProgressCache.add(resourceIRI);

  const callYield = call(API.fetch, resourceIRI);

  try {

    const receivedData = yield callYield;

    if (!receivedData) {

      // noinspection ExceptionCaughtLocallyJS
      throw new UserFriendlyError('Sorry.  We were unable to retrieve the requested information.');

    }

    const successAction = fetchApiResourceSuccess({...payload, ...meta, receivedData});

    yield put(successAction);

  } catch (error) {

    Raven.captureException(error);

    const failureAction = fetchApiResourceFailure(error, {...payload, ...meta});

    yield put(failureAction);

  } finally {

    requestsInProgressCache = requestsInProgressCache.delete(resourceIRI);

  }

}


export default handleApiFetchRequests;



// WEBPACK FOOTER //
// ./src/sagas/resources/handleApiFetchRequests.js